import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { GuardianViewModel } from '../Registration/Guardian';
import Form from 'react-jsonschema-form-bs4';
import { JsonForm } from '../Forms/jsonForm';
import arrayFieldTemplate from '../Forms/arrayFieldTemplate';
import Address from '../Forms/fields/address';
import Phone from '../Forms/fields/phone';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    isLoading: boolean;
    index: number;
    Guardians: GuardianViewModel[];
    form: JsonForm|undefined;
    childId: number;
}

export default class ChildGuardians extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            index: 0,
            Guardians: [],
            form: undefined,
            childId: 0,
        }

        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
    }


    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestGuardian(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.Guardians && this.state.childId != childId) {
            this.requestGuardian(childId);
        }
    }


    public render() {
        return <div>
            <DocumentTitle title="Guardians" />
            <br/>
            {this.state.form && <Form
                showErrorList={false}
                schema={this.state.form.Schema}
                uiSchema={this.state.form.UISchema}
                formData={{guardians: this.state.Guardians}}
                onSubmit={(e) => this.save(e.formData.guardians)}
                ArrayFieldTemplate={(props) => arrayFieldTemplate(props, this.delete)}
                fields={{ address: Address, phone: Phone }}
            >
                {!this.state.isLoading && <button type="submit" className="btn btn-primary">Save</button>}
                {this.state.isLoading && <div className="k-loading-image"></div>}
            </Form>}
            <br/>
            <br/>
        </div>
    }

    private requestGuardian(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/Children/GetGuardians/${childId}`)
            .then((response: { ChildID: number, Guardians: GuardianViewModel[], Form: JsonForm}) => {
                response.Form.Schema = JSON.parse(response.Form.Schema);
                response.Form.UISchema = JSON.parse(response.Form.UISchema);
                this.setState({ isLoading: false, Guardians: response.Guardians, form: response.Form });
            });
    }

    private save(data: GuardianViewModel[]) {
        this.setState({ isLoading: true, Guardians: data });
        fetchApi(`api/Children/SaveGuardian/${this.state.childId}`, data, 'POST')
            .then(() => {
                this.setState({ isLoading: false });

            }).catch((error: Error) => {
                this.setState({ isLoading: false });
                // TODO: Show error
            })
    }

    private async delete(data: GuardianViewModel): Promise<Boolean> {
        if (data.GuardianID > 0) {
            if (confirm(`Are you sure you want to delete ${data.FirstName} ${data.LastName}?`)) {
                return await fetchApi(`api/Children/DeleteGuardian/${data.GuardianID}`, {}, 'DELETE')
                    .then(() => { return true; })
                    .catch(() => { return false; });
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
}
